module.exports = __webpack_public_path__ + "static/media/detail_edit.fc509770.svg";